import React, { useRef, useCallback, useEffect } from "react";

const TOOLBAR_BUTTONS = [
  { cmd: "bold", icon: "B", title: "Bold", style: "font-bold" },
  { cmd: "italic", icon: "I", title: "Italic", style: "italic" },
  { cmd: "underline", icon: "U", title: "Underline", style: "underline" },
  { type: "separator" },
  { cmd: "formatBlock", arg: "H2", icon: "H2", title: "Heading 2", style: "font-bold text-xs" },
  { cmd: "formatBlock", arg: "H3", icon: "H3", title: "Heading 3", style: "font-bold text-xs" },
  { type: "separator" },
  { cmd: "insertUnorderedList", icon: "\u2022", title: "Bullet List" },
  { cmd: "insertOrderedList", icon: "1.", title: "Numbered List" },
  { cmd: "formatBlock", arg: "BLOCKQUOTE", icon: "\u201c", title: "Quote", style: "text-lg" },
  { type: "separator" },
  { cmd: "createLink", icon: "\ud83d\udd17", title: "Insert Link" },
  { cmd: "removeFormat", icon: "\u2715", title: "Clear Formatting", style: "text-red-500 text-xs" },
];

const RichTextEditor = ({ value, onChange, placeholder }) => {
  const editorRef = useRef(null);
  const isInternalUpdate = useRef(false);

  useEffect(() => {
    if (editorRef.current && !isInternalUpdate.current) {
      if (editorRef.current.innerHTML !== value) {
        editorRef.current.innerHTML = value || "";
      }
    }
    isInternalUpdate.current = false;
  }, [value]);

  const handleInput = useCallback(() => {
    if (editorRef.current) {
      isInternalUpdate.current = true;
      onChange(editorRef.current.innerHTML);
    }
  }, [onChange]);

  const execCmd = useCallback((cmd, arg) => {
    editorRef.current?.focus();
    if (cmd === "createLink") {
      const url = window.prompt("Enter URL:", "https://");
      if (url) document.execCommand(cmd, false, url);
    } else if (cmd === "formatBlock") {
      document.execCommand(cmd, false, `<${arg}>`);
    } else {
      document.execCommand(cmd, false, null);
    }
    handleInput();
  }, [handleInput]);

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden bg-white">
      <div className="flex flex-wrap items-center gap-0.5 px-2 py-1.5 border-b border-gray-200 bg-gray-50">
        {TOOLBAR_BUTTONS.map((btn, i) =>
          btn.type === "separator" ? (
            <div key={i} className="w-px h-5 bg-gray-300 mx-1" />
          ) : (
            <button
              key={i}
              type="button"
              title={btn.title}
              onMouseDown={(e) => { e.preventDefault(); execCmd(btn.cmd, btn.arg); }}
              className={`w-8 h-8 flex items-center justify-center rounded hover:bg-gray-200 text-gray-700 text-sm transition-colors ${btn.style || ""}`}
            >
              {btn.icon}
            </button>
          )
        )}
      </div>
      <div
        ref={editorRef}
        contentEditable
        onInput={handleInput}
        data-placeholder={placeholder || "Write here..."}
        className="min-h-[160px] px-4 py-3 text-sm text-gray-800 leading-relaxed outline-none [&:empty]:before:content-[attr(data-placeholder)] [&:empty]:before:text-gray-400"
        style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
      />
    </div>
  );
};

export default RichTextEditor;
